import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  formControl: {
    minWidth: '12em',
    width: '100%',
    fontSize: '12px',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: 2,
  },
  inputField: {
    minHeight: '2.7em',
    height: 'fit-content',
    width: '100%',
    color: theme.palette.text.primary,
    '& .MuiInputBase-input': {
      paddingTop: theme.spacing(2),
    },
  },
  errorText: {
    minHeight: '2em',
  },
  disabled: {
    opacity: '0.4',
  },

  fieldAndInfoWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(0.5),
    alignItems: 'end',
    color: theme.palette.text.primary,
  },
  fieldTextSize: {
    fontSize: '12px',
  },
  infoIcon: { width: '16px !important', color: theme.palette.text.secondary },
  calendarIcon: {
    '&.MuiSvgIcon-root': {
      height: '17px',
      width: '16px',
    },
  },
  inputTextField: {
    width: '50%',
    ['@media (max-width:960px)']: {
      width: '90%',
    },
  },

  content: {
    padding: theme.spacing(2, 0, 0, 1.6),
  },

  linkText: {
    color: theme.palette.opaque.dark,
    textTransform: 'none',
    marginLeft: theme.spacing(0.4),
    '&:hover': {
      backgroundColor: 'inherit',
      textDecoration: 'none',
    },
  },
  azureButton: {
    paddingTop: theme.spacing(2),
  },
  grid: {
    marginBottom: theme.spacing(0),
  },
}))
